export default __webpack_public_path__ + "static/media/busError.457afc51.svg";